import React, { Component } from 'react';
import Search from '../../components/Search';
import DataTable from '../../components/DataTable';
import { connect } from 'react-redux'
import {Card, CardBody, CardTitle, CardHeader} from "reactstrap";
import { setSearchData } from '../../actions/search';
import {fetchFrontEndUser} from '../../actions/frontEndUser'
import Loader from '../../components/Loader';
import { setSearchScope } from '../../helpers';
class FrontEndUser extends Component {

	constructor(props,context) {
        super(props,context);

        this.additionalColumns = [
         {
            Header: 'Actief',
            accessor: 'is_active',
            Cell: props => <span>{props.value === '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</span>
        },{
            Header: 'Is een hoofdgebruiker',
            accessor: 'is_main_account',
            Cell: props => <span>{props.value === '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</span>
        },{
            Header: 'Is een vertegenwoordiger',
            accessor: 'is_representative',
            Cell: props => <span>{props.value === '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</span>
        },{
            Header: 'Heeft de voorwaarden geaccepteerd',
            accessor: 'accepted_terms',
            Cell: props => <span>{props.value === '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</span>
        },{
            Header: 'Aanpassen',
            accessor: 'id',
            Cell: props => <span><a href={'/#/user/update/'+props.value} style={{display : 'inline'}} className="nav-link"><i className="fa fa-pencil"></i> Bewerken</a></span>
        }
        ]
        this.state = {columns: false}

    }

	componentWillMount() {
		setSearchScope('users');
    	if(this.props.clientPath) {
            this.props.fetchFrontEndUser(this.props.clientPath.clientPath)
			this.props.updateSearchData(this.props.frontEndUserData.data)
            this.setState({columns: this.props.frontEndUserData.columns})
        }
      }
      
      componentDidMount() {
        window.scrollTo(0, 0)
    }

    componentDidUpdate(prevProps, prevState) {
		if ( JSON.stringify(prevProps.frontEndUserData.data) !== JSON.stringify(this.props.frontEndUserData.data) ) {
            this.props.updateSearchData(this.props.frontEndUserData.data)
            this.setState({columns: this.props.frontEndUserData.columns})
        }
    }

	render() {
        const filterValues = {
            isActive : {
                name: 'Is Actief',
                type: 'checkbox',
                key: 'is_active',
                value : '1'
            },
            isNotActive : {
                name: 'Niet Actief',
                type: 'checkbox',
                key: 'is_active',
                value : '0'
            }
        }
        return (
 			<Card>
				<CardHeader><Search filters={filterValues} data={this.props.frontEndUserData.data} keys_to_filter={['name','parent_name','email','telephone']}/></CardHeader>
                <CardBody>
                    <CardTitle><i className="fa fa-user"></i> Gebruikers overzicht</CardTitle>
                    {this.state.columns ? <DataTable additionalColumns={this.additionalColumns} data={this.props.searchData.data ? this.props.searchData.data : this.props.frontEndUserData.data} columns={this.state.columns} /> : <Loader />}
                </CardBody>
            </Card>
        )
  	}
}


function mapStateToProps(state, ownProps) {

    return {
       frontEndUserData: state.FrontEndUserReducer,
       searchData: state.SearchDataReducer,
       clientPath: state.clientPathReducer,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSearchData: (data) => dispatch(setSearchData(data)),
        fetchFrontEndUser: (url) => dispatch(fetchFrontEndUser(url + '/api/frontenduser/action/getUsers'))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FrontEndUser)



// WEBPACK FOOTER //
// ./src/views/User/index.js